import Sticky from 'sticky-js'
import { useIntersectionObserver } from '../helpers'

class BlogHero {
    constructor(el) {
        const sticky = !self.Decimal.isMobile && new Sticky('.heading-to-stick')

        this.menu = self.Decimal.isMobile ? document.querySelector('.mobile-navigation') : document.querySelector('.main-navigation')
        this.textElements = this.menu.querySelectorAll('ul li, .container-x, .border-white')

        useIntersectionObserver(this, el)
        el.resetOnExit = true
    }

    onViewportEnter() {
        /*   this.menu.style.mixBlendMode = 'normal'
            this.textElements.forEach(el => {
                el.style.color = '#000',
                    el.style.borderColor = '#000'
            }) */
    }

    onViewportExit() {
        /* this.menu.style.mixBlendMode = 'difference'
            this.textElements.forEach(el => {
                el.style.color = '#fff'
                el.style.borderColor = '#fff'
            }) */
    }
}

// IIFE to invoke component on mount
(function init() {
    const blogHeroElement = document.querySelector('[data-blog-hero]')

    const blogHero = new BlogHero(blogHeroElement)

    self.Decimal.components.LogoHero = { ...blogHero, async: true }
})()
